import type { ApprovalChain } from '../approval-chain.model';

export const TRUST_REGISTRATION_CHAIN: ApprovalChain = {
  id: 'trust-registration',
  label: 'Notarial Deed of Donation and Trust',
  applicationTypes: ['TRUST_REGISTRATION'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'REGISTRY', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'REGISTRY_RECOMMENDED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED', 'REGISTRY_RECOMMENDED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
